import type { PropsWithChildren } from "react";

import { LayoutGroup } from "motion/react";
import { twMerge } from "tailwind-merge";

import { DragProvider, type DragMoveEvent } from "../context/DragProvider";

export function DragContainer({
  children,
  className,
  onMove,
}: PropsWithChildren<{
  className?: string;
  onMove: (move: DragMoveEvent) => void;
}>) {
  return (
    <DragProvider onMove={onMove}>
      <div data-drag-container className={twMerge("relative", className)}>
        <LayoutGroup>{children}</LayoutGroup>
      </div>
    </DragProvider>
  );
}
